import { Check } from "lucide-react";
import { rotating } from "@/content/siteContent";
import { Reveal } from "./Reveal";

export default function RotatingBadge() {
  return (
    <section className="border-y border-metal bg-graphite py-24 md:py-32" data-testid="rotating-badge-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 md:px-8 lg:grid-cols-2">
        <div>
          <Reveal>
            <div className="microtitle-row mb-5">
              <p className="microtitle">{rotating.microtitle}</p>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-paper sm:text-5xl">
              {rotating.titleA}
              <br />
              {rotating.titleB}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-md text-base leading-relaxed text-mist">{rotating.paragraph}</p>
          </Reveal>
          <Reveal delay={0.24}>
            <ul className="mt-8 space-y-3">
              {rotating.points.map((point) => (
                <li key={point} className="flex items-center gap-3 text-sm font-semibold text-paper">
                  <span className="check-industrial">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  {point}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="flex justify-center lg:justify-end">
          <div className="rotator relative h-[300px] w-[300px] sm:h-[380px] sm:w-[380px] md:h-[440px] md:w-[440px]" data-testid="rotating-badge">
            <div className="absolute inset-0 rounded-full border border-metal" />
            <div
              className="absolute inset-2 rounded-full opacity-60"
              style={{
                backgroundImage:
                  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='49' viewBox='0 0 28 49'%3E%3Cpath d='M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z' fill='%2317191C'/%3E%3C/svg%3E\")",
              }}
            />
            <div
              className="absolute inset-2 rounded-full"
              style={{
                background:
                  "conic-gradient(from 200deg, rgba(90,94,99,.5), rgba(43,46,50,.15), rgba(106,110,115,.5), rgba(35,38,42,.15), rgba(90,94,99,.5))",
                mask: "radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2px))",
                WebkitMask: "radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2px))",
              }}
            />
            <div className="absolute inset-0">
              {[0, 45, 90, 135, 180, 225, 270, 315].map((deg) => (
                <span
                  key={deg}
                  className="absolute left-1/2 top-1/2 h-[6px] w-[2px] origin-[0_0] bg-steel"
                  style={{ transform: `rotate(${deg}deg) translate(-1px, -148px)` }}
                />
              ))}
            </div>

            <svg viewBox="0 0 300 300" className="rotator-text absolute inset-0 h-full w-full">
              <defs>
                <path id="sagarelo-circle" d="M150,150 m-118,0 a118,118 0 1,1 236,0 a118,118 0 1,1 -236,0" />
              </defs>
              <text className="fill-mist font-display" style={{ fontSize: "12.5px", letterSpacing: "3.5px", fontWeight: 700 }}>
                <textPath href="#sagarelo-circle">{rotating.text}</textPath>
              </text>
            </svg>

            <div className="absolute inset-[19%] overflow-hidden rounded-full border border-metal shadow-[0_20px_50px_-20px_rgba(0,0,0,0.9)]">
              <img
                src={rotating.centerImage}
                alt="Equipamento de climatização instalado pela Sagarelo"
                loading="lazy"
                className="h-full w-full object-cover"
                data-testid="rotating-center-image"
              />
              <div className="absolute inset-0 rounded-full shadow-[inset_0_0_0_2px_rgba(245,176,0,0.35)]" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
